export enum ESlideState {
  Active = 'active',
  ActiveLeft = 'activeLeft',
  ActiveRight = 'activeRight',
  PreviousLeft = 'previousLeft',
  PreviousRight = 'previousRight',
  Hidden = 'hidden'
}